export default __webpack_public_path__ + "static/media/March2021.2ec4f1ad.png";